vi.mock('../hooks/useLayoutEvent', () => ({
  useLayoutEvent: vi.fn(),
}));

export {};
